/**
 * Lightweight in-memory view state so list → detail → back can restore
 * filters and scroll without persisting across full page reloads.
 */

export type ServicesListViewState = {
  search: string;
  filter: "all" | "active" | "inactive";
  scrollY: number;
};

export type GroupsListViewState = {
  entity: string;
  scrollY: number;
};

export type SyncHistoryViewState = {
  entity: string;
  status: string;
  limit: number;
  offset: number;
  scrollY: number;
};

let servicesList: ServicesListViewState | null = null;
let groupsList: GroupsListViewState | null = null;
let syncHistory: SyncHistoryViewState | null = null;

export function stashServicesListState(state: ServicesListViewState): void {
  servicesList = state;
}

export function takeServicesListState(): ServicesListViewState | null {
  const state = servicesList;
  servicesList = null;
  return state;
}

export function stashGroupsListState(state: GroupsListViewState): void {
  groupsList = state;
}

export function takeGroupsListState(): GroupsListViewState | null {
  const state = groupsList;
  groupsList = null;
  return state;
}

export function stashSyncHistoryState(state: SyncHistoryViewState): void {
  syncHistory = state;
}

export function takeSyncHistoryState(): SyncHistoryViewState | null {
  const state = syncHistory;
  syncHistory = null;
  return state;
}

export function restoreWindowScroll(scrollY: number): void {
  requestAnimationFrame(() => {
    window.scrollTo(0, scrollY);
  });
}
